<mat-form-field class="search" [ngClass]="{'search-open': open == true}">
    <input matInput placeholder="Search" autocomplete="off"
           (focus)="bigMenu = true"
           (focusout)="bigMenu = false">
</mat-form-field>
